import {
  FaChevronLeft,
  FaSearch,
  FaSortDown,
  FaSortUp,
  FaChevronRight,
  FaTrash,
  FaTimes,
} from "react-icons/fa";
import "./NewRequestview.css";
import { useContext, useEffect, useState } from "react";
import { IoIosClose } from "react-icons/io";
import { UserContext } from "../../context/UserContext";
import { BASE_URL } from "../../constants";

const AccidentDetailsScreen = ({
  client,
  setShowAccidentDetailsScreen,
  dateRanges,
  accidentDate,
  setAccidentDate,
  natureOfAccident,
  setNatureOfAccident,
  policyNumber,
  setPolicyNumber,
  adjusterName,
  setAdjusterName,
  adjusterEmail,
  setAdjusterEmail,
  selectedProducts,
  setSelectedProducts,
  setShowUrgentServicesScreen,
  isOhipRequest,
  selectedProvider,
  resetAllStates,
  onBack,
  handleBack,
}) => {
  const products = [
    "Extended Healthcare File",
    "Collateral Benefits File",
    "Summary of Benefits Paid to Date",
    "Property Damage File",
    "Benefits Booklet",
    "Independent Examination Reports",
    "Accident Benefit File",
  ];

  const toggleProduct = (product) => {
    if (selectedProducts.includes(product)) {
      setSelectedProducts(selectedProducts.filter((p) => p !== product));
    } else {
      setSelectedProducts([...selectedProducts, product]);
    }
  };

  const isFormValid =
    accidentDate && natureOfAccident && selectedProducts.length > 0;

  return (
    <div className="accident-detail-screen">
      <button
        className="accident-detail-screen__back-button"
        onClick={() => {
          resetAllStates();
          onBack();
        }}
      >
        <FaChevronLeft className="accident-detail-screen__back-icon" /> Back to
        Client
      </button>

      <h2 className="accident-detail-screen__title">
        New Request / {client.first_name} {client.last_name} (
        {client.file_number ?? "CLA-001"})
      </h2>
      <div className="accidental-detail-screen-content">
        <div className="accident-detail-screen__header-card">
          <p>
            You are requesting medical records from{" "}
            {isOhipRequest
              ? "Ministry of Health and Long-Term Care"
              : selectedProvider.provider}
            , for all dates from {dateRanges[0]?.from} to {dateRanges[0]?.to}.
          </p>
          <p>To continue, please select your products.</p>
        </div>

        <div className="accident-detail-screen__form">
          <div className="accident-detail-screen__form-row">
            <div className="accident-detail-screen__form-group">
              <label>Policy/Claim No.</label>
              <input
                type="text"
                value={policyNumber}
                onChange={(e) => setPolicyNumber(e.target.value)}
                placeholder="Enter policy/claim number"
                className="accident-detail-screen__input"
              />
            </div>

            <div className="accident-detail-screen__form-group">
              <label>Adjuster Name</label>
              <input
                type="text"
                value={adjusterName}
                onChange={(e) => setAdjusterName(e.target.value)}
                placeholder="Enter adjuster's name"
                className="accident-detail-screen__input"
              />
            </div>

            <div className="accident-detail-screen__form-group">
              <label>Adjuster Email</label>
              <input
                type="email"
                value={adjusterEmail}
                onChange={(e) => setAdjusterEmail(e.target.value)}
                placeholder="Enter adjuster's email"
                className="accident-detail-screen__input"
              />
            </div>
          </div>

          <div className="accident-detail-screen__form-row">
            <div className="accident-detail-screen__form-group">
              <label>Date of Accident *</label>
              <input
                type="date"
                value={accidentDate}
                onChange={(e) => setAccidentDate(e.target.value)}
                className="accident-detail-screen__input"
              />
            </div>

            <div className="accident-detail-screen__form-group">
              <label>Nature of Accident *</label>
              <input
                type="text"
                value={natureOfAccident}
                onChange={(e) => setNatureOfAccident(e.target.value)}
                placeholder="Describe nature of accident"
                className="accident-detail-screen__input"
              />
            </div>
          </div>

          <div className="accident-detail-screen__products">
            <h3 className="accident-detail-screen__section-title">
              Documents to Provide
            </h3>
            <div className="accident-detail-screen__products-grid">
              {products.map((product) => (
                <div
                  key={product}
                  className={`accident-detail-screen__product-card ${
                    selectedProducts.includes(product)
                      ? "accident-detail-screen__product-card--selected"
                      : ""
                  }`}
                  onClick={() => toggleProduct(product)}
                >
                  <input
                    type="checkbox"
                    checked={selectedProducts.includes(product)}
                    onChange={() => toggleProduct(product)}
                    onClick={(e) => e.stopPropagation()} // prevent card click doubling toggle
                    className="accident-detail-screen__product-checkbox-input"
                  />
                  <span className="accident-detail-screen__product-name">
                    {product}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="accident-detail-screen__actions">
          <button className="cancel-button" onClick={handleBack}>
            Back
          </button>
          <button
            className="next-button"
            onClick={() => {
              setShowAccidentDetailsScreen(false);
              setShowUrgentServicesScreen(true);
            }}
            disabled={!isFormValid}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

const UrgentServiceScreen = ({
  client,
  dateRanges,
  isUrgent,
  setIsUrgent,
  dueDate,
  setDueDate,
  setShowUrgentServicesScreen,
  setShowConfirmationScreen,
  isOhipRequest,
  selectedProvider,
  resetAllStates,
  onBack,
  handleBack,
}) => {
  return (
    <div className="urgent-service-screen">
      <button
        className="urgent-service-screen__back-link"
        onClick={() => {
          resetAllStates();
          onBack();
        }}
      >
        <FaChevronLeft className="accident-detail-screen__back-icon" /> Back to
        Client
      </button>
      <h2 className="accident-detail-screen__title">
        New Request / {client.first_name} {client.last_name} (
        {client.file_number ?? "CLA-001"})
      </h2>
      <div className="urgent-service-screen__card">
        <div className="urgent-service-screen__request-info">
          <p>
            You are requesting medical records from{" "}
            {isOhipRequest
              ? "Ministry of Health and Long-Term Care"
              : selectedProvider.provider}
            , for all dates from (Y/M/D) {dateRanges[0]?.from} to{" "}
            {dateRanges[0]?.to}.
          </p>
          <p>
            Note: Your standard Nobel Flow service fee applies on new requests.
          </p>
        </div>

        <h2 className="urgent-service-screen__section-title">
          Special Notes to Provider
        </h2>
        <label className="urgent-service-screen__section-description">
          If you have specific requirements about the request to communicate
          directly to the provider (such as a specific record within the date
          range), please note them here. (max 500 characters)
        </label>

        <textarea
          className="urgent-service-screen__textarea"
          rows="6"
          placeholder="Add any extra notes or instructions here"
        ></textarea>

        <hr className="urgent-service-screen__divider" />

        <h2 className="urgent-service-screen__title">Urgent Service Add-On</h2>

        <div className="urgent-service-screen__info">
          <p>
            By adding on Urgent Service, you are granting to pay an additional
            non-neturnable $12.00 Nobel Flow Urgent Service fee, and a
            pre-authorize $390.0 re-payment for the provider, that will be used
            to pay for the records and provider's service.
          </p>
          <p>
            Please note that if the full pre-authorize a $300 pre-payment is not
            used or only partially used, the remainder will be refunded. The
            pre-payment is required to reduce turnover.
          </p>
          <p>
            Once Urgent Service is added on our team will promptly call the
            provider to communicate the urgency of the request on top of our
            Standard Request Service. We cannot guarantee the due date will be
            honoured by the provider.
          </p>
        </div>

        <div className="urgent-service-screen__option">
          <input
            type="checkbox"
            id="urgentService"
            checked={isUrgent}
            onChange={(e) => setIsUrgent(e.target.checked)}
            className="urgent-service-screen__checkbox"
          />
          <label htmlFor="urgentService">
            Add-On Urgent Service (Nobel Flow Urgent fees apply)
          </label>
        </div>

        {isUrgent && (
          <div className="urgent-service-screen__due-date">
            <label>Due Date to communication to the provider (optional)</label>
            <input
              type="date"
              value={dueDate}
              onChange={(e) => setDueDate(e.target.value)}
              placeholder="YYYY-MM-DD"
              className="urgent-service-screen__date-input"
            />
          </div>
        )}

        <div className="accident-detail-screen__actions">
          <button className="cancel-button" onClick={handleBack}>
            Back
          </button>
          <button
            className="next-button"
            onClick={() => {
              setShowUrgentServicesScreen(false);
              setShowConfirmationScreen(true);
            }}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

const ConfirmationScreen = ({
  client,
  isUrgent,
  resetAllStates,
  dateRanges,
  isOhipRequest,
  selectedProvider,
  handleBack,
  onBack,
  submitRequest,
}) => {
  const [showActionItemsDialog, setShowActionItemsDialog] = useState(false);
  const [isAddedToActionItems, setIsAddedToActionItems] = useState(false);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [files, setFiles] = useState([]);

  const handleUploadDocuments = async (files) => {
    if (!files || files.length === 0) {
      alert("Please select at least one file before uploading.");
      return;
    }
    const fileNames = files.map((f) => f.name).join(", ");
    alert(`📄 Uploaded successfully: ${fileNames}`);
  };

  return (
    <div className="confirmation-screen">
      <h1
        className="confirmation-screen__back-link"
        onClick={() => {
          setIsAddedToActionItems(false);
          resetAllStates();
          onBack();
        }}
      >
        <FaChevronLeft /> Back to Client
      </h1>

      <h2 className="confirmation-screen__title">
        New Request / {client.first_name} {client.last_name} (
        {client.file_number ?? "CLA-001"})
      </h2>

      <div className="confirmation-screen__request-info">
        <p>
          You are requesting medical records from{" "}
          {isOhipRequest
            ? "Ministry of Health and Long-Term Care"
            : selectedProvider.provider}
          , for all dates from (Y/M/D) {dateRanges[0]?.from} to{" "}
          {dateRanges[0]?.to}.
        </p>
        <p>
          Note: Your standard Nobel Flow service fee applies on new requests.
        </p>
      </div>

      <div className="confirmation-screen__requirements">
        <h3>Requirements Missing</h3>
        <p>
          One or more items in your request require additional documents or
          information before being processed. See below for specifications. If
          you do not have those requirements now, you can place this request in
          your pending queue for later.
        </p>
      </div>

      {isOhipRequest && (
        <div className="confirmation-screen__missing-health-card">
          <h3>Upload Health Card</h3>
          <p>
            Please note that the OHIP request you are submitting a request for
            requires a Health Card to be uploaded to the Client's profile.
            Please upload the Client's Health Card below or navigate to the
            Photo ID section of the Client profile to upload.
          </p>
        </div>
      )}

      <div className="confirmation-screen__missing-doc">
        <p>
          <strong>
            Substitute Decision Maker document missing or not valid
          </strong>
          <br />
          The client doesn't have the required valid Substitute Decision Maker.
          Please add this request to your Pending page and verify the documents
          on the client's profile page.
        </p>
      </div>

      <div className="fee-table-container">
        <table className="fee-table">
          <thead>
            <tr className="fee-table__header-row">
              <th className="fee-table__header fee-table__product-type">
                Product Type
              </th>
              <th className="fee-table__header fee-table__attention-items">
                Attention Items
              </th>
              <th className="fee-table__header fee-table__fees">
                Provider Prepayment Fees
              </th>
            </tr>
          </thead>
          <tbody>
            {isOhipRequest ? (
              <tr className="fee-table__row">
                <td className="fee-table__data fee-table__product-type">
                  History
                </td>
                <td className="fee-table__data fee-table__attention-items">
                  <div className="attention-items-list">
                    <span>Third Party Personal Claims History</span>
                  </div>
                </td>
                <td className="fee-table__data fee-table__fees">$74.00</td>
              </tr>
            ) : (
              <>
                <tr className="fee-table__row">
                  <td className="fee-table__data fee-table__product-type">
                    Insurance
                  </td>
                  <td className="fee-table__data fee-table__attention-items">
                    <div className="attention-items-list">
                      <span>Extended Healthcare File</span>
                      <span>Property Damage File</span>
                      <span>Property Damage File</span>
                      <span>Property Damage File</span>
                      <span>Property Damage File</span>
                    </div>
                  </td>
                  <td className="fee-table__data fee-table__fees">$0.00</td>
                </tr>
                {isUrgent && (
                  <tr className="fee-table__row">
                    <td className="fee-table__data fee-table__product-type">
                      Urgent Provider Fee
                    </td>
                    <td className="fee-table__data fee-table__attention-items"></td>
                    <td className="fee-table__data fee-table__fees">$300.00</td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </table>
      </div>

      <div className="confirmation-screen__button-group">
        {!isAddedToActionItems ? (
          isOhipRequest ? (
            <button
              className="confirmation-screen__button confirmation-screen__button--sign"
              disabled={true}
            >
              Sign & Submit
            </button>
          ) : (
            <>
              <button
                className="confirmation-screen__button confirmation-screen__button--sign"
                disabled={true}
              >
                Sign & Submit
              </button>
              <button
                className="confirmation-screen__button confirmation-screen__button--action"
                onClick={() => {
                  setShowActionItemsDialog(true);
                  setIsAddedToActionItems(true);
                  submitRequest();
                }}
              >
                Add to Action Items
              </button>
              <button
                className="confirmation-screen__button confirmation-screen__button--upload"
                onClick={() => setIsUploadModalOpen(true)}
              >
                Upload Documents
              </button>
              <button
                className="confirmation-screen__button confirmation-screen__button--back"
                onClick={handleBack}
              >
                Back
              </button>
            </>
          )
        ) : (
          <button
            className="confirmation-screen__button confirmation-screen__button--action"
            onClick={() => {
              //navigate to action items
              setIsAddedToActionItems(false);
              resetAllStates();
            }}
          >
            Go to Action Items
          </button>
        )}
      </div>
      {showActionItemsDialog && (
        <div className="dialog-overlay">
          <div className="dialog-container">
            <div className="dialog-header">
              <h2>What do you want to do now?</h2>
              <button
                className="close-button"
                onClick={() => {
                  setShowActionItemsDialog(false);
                }}
              >
                <IoIosClose size={30} />
              </button>
            </div>

            <div className="dialog-content">
              <p>
                Your request has been added to the pending list. If you'd like
                to place another request for this client, click "Make Another
                Request". Otherwise, click "Go to Action Items" to process your
                request.
              </p>

              <div className="divider"></div>

              <div className="action-buttons">
                <button
                  className="primary-button"
                  onClick={() => {
                    setIsAddedToActionItems(false);
                    resetAllStates();
                  }}
                >
                  Make Another Request
                </button>
                <button
                  className="primary-button"
                  onClick={() => {
                    //navigate to action items
                    setIsAddedToActionItems(false);
                    resetAllStates();
                  }}
                >
                  Go to Action Items
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Upload Files Modal */}
      {isUploadModalOpen && (
        <div className="upload-docs-overlay">
          <div className="upload-docs-modal">
            {/* Close X button */}
            <button
              className="upload-docs-close"
              onClick={() => setIsUploadModalOpen(false)}
            >
              <FaTimes />
            </button>

            <h2>Upload Documents</h2>

            <div className="upload-docs-section">
              <div
                className="upload-docs-drop-zone"
                onClick={() =>
                  document.getElementById("hiddenUploadFileInput").click()
                }
              >
                {files.length > 0 ? (
                  <ul>
                    {files.map((f, index) => (
                      <li key={index}>📄 {f.name}</li>
                    ))}
                  </ul>
                ) : (
                  <span>📂 Click or Tap here to select files</span>
                )}
              </div>
              <input
                id="hiddenUploadFileInput"
                type="file"
                multiple
                style={{ display: "none" }}
                onChange={(e) => setFiles(Array.from(e.target.files))}
              />
              <button
                className="upload-docs-button"
                onClick={() => {
                  handleUploadDocuments(files);
                  setFiles([]); // reset after upload
                  setIsUploadModalOpen(false);
                }}
                disabled={files.length === 0}
              >
                Upload
              </button>

              <button
                className="upload-docs-close-btn"
                onClick={() => setIsUploadModalOpen(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const NewRequestHeader = ({ client, handleOhipRequestClick }) => (
  <div className="new-request-header-container">
    <h1 className="new-request-title">
      New Request / {client.first_name} {client.last_name}
    </h1>
    <button
      className="new-request-search-button"
      onClick={handleOhipRequestClick}
    >
      OHIP Request
    </button>
  </div>
);

export default function NewRequestView({ client, onBack }) {
  const [activeProviderTab, setActiveProviderTab] = useState("Hospital");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [isOhipRequest, setIsOhiprequest] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [hasAgreed, setHasAgreed] = useState(false);
  const [showDateRangeScreen, setShowDateRangeScreen] = useState(false);
  const [dateRanges, setDateRanges] = useState([
    { from: "", to: "", includePresent: false },
  ]);
  const [requestLabel, setRequestLabel] = useState("");
  const [doctors, setDoctors] = useState([""]);
  const [providerData, setProviderData] = useState({});

  //Accident Details Screen
  const [showAccidentDetailsScreen, setShowAccidentDetailsScreen] =
    useState(false);
  const [accidentDate, setAccidentDate] = useState("");
  const [natureOfAccident, setNatureOfAccident] = useState("");
  const [policyNumber, setPolicyNumber] = useState("");
  const [adjusterName, setAdjusterName] = useState("");
  const [adjusterEmail, setAdjusterEmail] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([]);

  //Urgent Service Screen
  const [showUrgentServicesScreen, setShowUrgentServicesScreen] =
    useState(false);
  const [isUrgent, setIsUrgent] = useState(false);
  const [dueDate, setDueDate] = useState("");

  //Confirmation Screen
  const [showConfirmationScreen, setShowConfirmationScreen] = useState(false);

  const {
    user: { id: userId, lawyer_id },
  } = useContext(UserContext);

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const getSortedItems = (data) => {
    const sortableItems = [...(data[activeProviderTab] || [])];

    if (sortConfig.key) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  };

  const handleDateRangeChange = (index, field, value) => {
    const updatedRanges = [...dateRanges];
    updatedRanges[index][field] = value;
    setDateRanges(updatedRanges);
  };

  const addDateRange = () => {
    if (dateRanges.length < 3) {
      setDateRanges([
        ...dateRanges,
        { from: "", to: "", includePresent: false },
      ]);
    }
  };

  const removeDateRange = (index) => {
    const updatedRanges = dateRanges.filter((_, i) => i !== index);
    setDateRanges(updatedRanges);
  };

  const handleDoctorChange = (index, value) => {
    const updatedDoctors = [...doctors];
    updatedDoctors[index] = value;
    setDoctors(updatedDoctors);
  };

  const addDoctor = () => {
    if (doctors.length < 3) {
      setDoctors([...doctors, ""]);
    }
  };

  const removeDoctor = (index) => {
    const updatedDoctors = doctors.filter((_, i) => i !== index);
    setDoctors(updatedDoctors);
  };

  const isDateRangeValid = () => {
    return (
      dateRanges.some(
        (range) => range.from || range.to || range.includePresent
      ) && dateRanges.every((range) => range.from < range.to)
    );
  };

  const handleNext = () => {
    if (isDateRangeValid()) {
      setShowDateRangeScreen(false);
      if (isOhipRequest) {
        setShowConfirmationScreen(true);
      } else {
        setShowAccidentDetailsScreen(true);
      }
    }
  };

  const resetAllStates = () => {
    setActiveProviderTab("Hospital");
    setSortConfig({ key: null, direction: "asc" });
    setIsOhiprequest(false);
    setIsModalOpen(false);
    setSelectedProvider(null);
    setHasAgreed(false);
    setShowDateRangeScreen(false);
    setDateRanges([{ from: "", to: "", includePresent: false }]);
    setRequestLabel("");
    setDoctors([""]);

    // Accident Details
    setShowAccidentDetailsScreen(false);
    setAccidentDate("");
    setNatureOfAccident("");
    setPolicyNumber("");
    setAdjusterName("");
    setAdjusterEmail("");
    setSelectedProducts([]);

    // Urgent Service
    setShowUrgentServicesScreen(false);
    setIsUrgent(false);
    setDueDate("");

    // Confirmation
    setShowConfirmationScreen(false);
  };

  const handleOhipRequestClick = () => {
    setIsOhiprequest(true);
    setShowDateRangeScreen(true);
  };

  const handleBack = () => {
    if (showDateRangeScreen) {
      resetAllStates();
    } else if (showAccidentDetailsScreen) {
      setShowAccidentDetailsScreen(false);
      setShowDateRangeScreen(true);
    } else if (showUrgentServicesScreen) {
      setShowUrgentServicesScreen(false);
      setShowAccidentDetailsScreen(true);
    } else if (showConfirmationScreen) {
      setShowConfirmationScreen(false);
      isOhipRequest
        ? setShowDateRangeScreen(true)
        : setShowUrgentServicesScreen(true);
    }
  };

  const buildRequestPayload = () => {
    if (isOhipRequest) {
      return {
        userId,
        clientId: client.id.toLowerCase(),
        lawyerId: lawyer_id.toLowerCase(),
        providerId: -1,
        provider: "Ministry of Health and Long-Term Care",
        dateRanges,
        isOhipRequest: true,
      };
    } else {
      console.log("id:", selectedProvider.id);
      return {
        userId,
        clientId: client.id.toLowerCase(),
        providerId: selectedProvider.id.toLowerCase(),
        lawyerId: lawyer_id.toLowerCase(),
        provider: selectedProvider.provider,
        dateRanges,
        accidentDetails: {
          accidentDate,
          natureOfAccident,
          policyNumber,
          adjusterName,
          adjusterEmail,
        },
        selectedProducts,
        urgentServiceDetails: {
          isUrgent,
          dueDate,
        },
        isOhipRequest: false,
      };
    }
  };

  const submitRequest = async () => {
    const payload = buildRequestPayload();

    try {
      const response = await fetch(`${BASE_URL}/api/requests`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const data = await response.json();
      console.log("Request submitted successfully:", data);
    } catch (error) {
      console.error("Failed to submit request:", error);
      alert("There was a problem submitting the request. Please try again.");
    }
  };

  const fetchAllProviders = async () => {
    try {
      const response = await fetch(`${BASE_URL}/api/medical-providers`); // fetch all providers
      const data = await response.json();

      if (data.success) {
        const grouped = data.providers.reduce((acc, provider) => {
          if (!acc[provider.category]) acc[provider.category] = [];
          acc[provider.category].push(provider);
          return acc;
        }, {});
        setProviderData(grouped); // save all providers in state
        console.log(grouped);
      } else {
        setProviderData({});
      }
    } catch (err) {
      console.error("Error fetching providers:", err);
      setProviderData({});
    }
  };

  useEffect(() => {
    fetchAllProviders();
  }, []);

  if (showDateRangeScreen) {
    return (
      <div className="date-range-screen">
        <button
          className="date-range-back-button"
          onClick={() => {
            resetAllStates();
            onBack();
          }}
        >
          <FaChevronLeft className="back-icon" /> Back to Client
        </button>

        <h2 className="date-range-title">
          New Request / {client.first_name} {client.last_name} (
          {client.file_number ?? "CLA-001"})
        </h2>

        <div className="date-range-card">
          <div className="date-range-header-card">
            <p className="date-range-header-text">
              You are requesting medical records from{" "}
              <span className="provider-name">
                {isOhipRequest
                  ? "Ministry of Health and Long-Term Care"
                  : selectedProvider.provider}
              </span>
              .
            </p>
            <div className="date-range-header-content">
              <p className="request-instruction">
                Please enter a specific date range that you would like to
                request records for.
              </p>
            </div>
          </div>

          <div className="date-range-section">
            <h3>
              Date Range (if multiple date ranges, enter in chronological order)
            </h3>

            {dateRanges.map((range, index) => (
              <div key={index} className="date-range-input-group">
                <div className="date-input">
                  <label>From</label>
                  <input
                    type="date"
                    value={range.from}
                    onChange={(e) =>
                      handleDateRangeChange(index, "from", e.target.value)
                    }
                    placeholder="YYYY-MM-DD"
                  />
                </div>

                <div className="date-input">
                  <label>To</label>
                  <input
                    type="date"
                    value={range.to}
                    onChange={(e) =>
                      handleDateRangeChange(index, "to", e.target.value)
                    }
                    placeholder="YYYY-MM-DD"
                  />
                </div>

                <label className="present-date-checkbox">
                  <input
                    type="checkbox"
                    checked={range.includePresent}
                    onChange={(e) =>
                      handleDateRangeChange(
                        index,
                        "includePresent",
                        e.target.checked
                      )
                    }
                  />
                  Present Date
                </label>

                {index > 0 && (
                  <button
                    className="remove-range-button"
                    onClick={() => removeDateRange(index)}
                    aria-label="Remove date range"
                  >
                    <FaTrash className="remove-icon" />
                  </button>
                )}
              </div>
            ))}

            {dateRanges.length < 3 && (
              <button className="add-range-button" onClick={addDateRange}>
                + Add Another Date Range
              </button>
            )}
          </div>

          <div className="request-label-section">
            <label>Request Label</label>
            <input
              type="text"
              value={requestLabel}
              onChange={(e) => setRequestLabel(e.target.value)}
              placeholder="Enter a label for this request"
            />
          </div>

          {!isOhipRequest && (
            <div className="doctors-section">
              <h3>You can add up to 3 doctor names</h3>
              {doctors.map((doctor, index) => (
                <div key={index} className="doctor-input">
                  <label>Doctor {index + 1}</label>
                  <input
                    type="text"
                    value={doctor}
                    onChange={(e) => handleDoctorChange(index, e.target.value)}
                    placeholder="Enter doctor name"
                  />
                  {index > 0 && (
                    <button
                      className="remove-doctor-button"
                      onClick={() => removeDoctor(index)}
                      aria-label="Remove doctor"
                    >
                      <FaTrash className="remove-icon" />
                    </button>
                  )}
                </div>
              ))}
              {doctors.length < 3 && (
                <button className="add-doctor-button" onClick={addDoctor}>
                  + Add Another Doctor
                </button>
              )}
            </div>
          )}

          <div className="date-range-actions">
            <button className="cancel-button" onClick={handleBack}>
              Cancel
            </button>
            <button
              className="next-button"
              onClick={handleNext}
              disabled={!isDateRangeValid()}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (showAccidentDetailsScreen) {
    return (
      <AccidentDetailsScreen
        {...{
          client,
          setShowAccidentDetailsScreen,
          selectedProvider,
          dateRanges,
          accidentDate,
          setAccidentDate,
          natureOfAccident,
          setNatureOfAccident,
          policyNumber,
          setPolicyNumber,
          adjusterName,
          setAdjusterName,
          adjusterEmail,
          setAdjusterEmail,
          selectedProducts,
          setSelectedProducts,
          setShowUrgentServicesScreen,
          isOhipRequest,
          resetAllStates,
          handleBack,
          onBack,
        }}
      />
    );
  }

  if (showUrgentServicesScreen) {
    return (
      <UrgentServiceScreen
        {...{
          client,
          dateRanges,
          isUrgent,
          setIsUrgent,
          dueDate,
          setDueDate,
          setShowAccidentDetailsScreen,
          setShowConfirmationScreen,
          isOhipRequest,
          selectedProvider,
          resetAllStates,
          handleBack,
          onBack,
          setShowUrgentServicesScreen,
        }}
      />
    );
  }

  if (showConfirmationScreen) {
    return (
      <ConfirmationScreen
        {...{
          client,
          isUrgent,
          setShowUrgentServicesScreen,
          resetAllStates,
          dateRanges,
          isOhipRequest,
          setIsOhiprequest,
          selectedProvider,
          submitRequest,
        }}
      />
    );
  }

  return (
    <div className="new-request-view">
      <button className="new-request-back-button" onClick={onBack}>
        <FaChevronLeft className="new-request-back-icon" /> Back to Client
      </button>

      <NewRequestHeader {...{ client, handleOhipRequestClick }} />

      {/* Search Section */}
      <div className="new-request-search-container">
        <h2 className="new-request-search-title">Search New Provider</h2>
        <div className="new-request-search-input-container">
          <input
            type="text"
            placeholder="Search provider..."
            className="new-request-search-input-field"
          />
          <button className="new-request-search-button">
            <FaSearch className="new-request-search-icon" /> Search
          </button>
        </div>
      </div>

      {/* Provider Tabs */}
      <div className="new-request-provider-tabs-container">
        <h2 className="new-request-provider-tabs-title">
          Select a Provider from:
        </h2>
        <div className="new-request-provider-tabs">
          {[...Object.keys(providerData)].map((provider) => (
            <button
              key={provider}
              className={`new-request-provider-tab ${
                activeProviderTab === provider
                  ? "new-request-provider-tab-active"
                  : ""
              }`}
              onClick={() => setActiveProviderTab(provider)}
            >
              {provider}
            </button>
          ))}
        </div>

        {/* Table Section */}
        <div className="new-request-table-controls">
          <div className="new-request-table-search-container">
            <input
              type="text"
              placeholder="Search"
              className="new-request-table-search-input"
            />
            <button className="new-request-table-clear-button">Clear</button>
          </div>
        </div>

        <div className="new-request-table-wrapper">
          <table className="new-request-data-table">
            <thead>
              <tr>
                <th
                  className="new-request-table-header"
                  onClick={() => requestSort("provider")}
                >
                  <div className="new-request-header-content">
                    Provider
                    {sortConfig.key === "provider" ? (
                      sortConfig.direction === "asc" ? (
                        <FaSortUp className="new-request-sort-icon" />
                      ) : (
                        <FaSortDown className="new-request-sort-icon" />
                      )
                    ) : (
                      <FaSortDown className="new-request-sort-icon inactive" />
                    )}
                  </div>
                </th>
                <th
                  className="new-request-table-header"
                  onClick={() => requestSort("city")}
                >
                  <div className="new-request-header-content">
                    City
                    {sortConfig.key === "city" ? (
                      sortConfig.direction === "asc" ? (
                        <FaSortUp className="new-request-sort-icon" />
                      ) : (
                        <FaSortDown className="new-request-sort-icon" />
                      )
                    ) : (
                      <FaSortDown className="new-request-sort-icon inactive" />
                    )}
                  </div>
                </th>
                <th
                  className="new-request-table-header"
                  onClick={() => requestSort("lastRequested")}
                >
                  <div className="new-request-header-content">
                    Last Requested Date
                    {sortConfig.key === "lastRequested" ? (
                      sortConfig.direction === "asc" ? (
                        <FaSortUp className="new-request-sort-icon" />
                      ) : (
                        <FaSortDown className="new-request-sort-icon" />
                      )
                    ) : (
                      <FaSortDown className="new-request-sort-icon inactive" />
                    )}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {getSortedItems(providerData).length > 0 ? (
                getSortedItems(providerData).map((row, index) => (
                  <tr
                    key={index}
                    className="new-request-table-row"
                    onClick={() => {
                      setSelectedProvider(row);
                      setIsModalOpen(true);
                    }}
                  >
                    <td className="new-request-table-cell">{row.provider}</td>
                    <td className="new-request-table-cell">{row.city}</td>
                    <td className="new-request-table-cell">
                      {new Date(row.lastRequested).toLocaleDateString("en-CA")}
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="new-request-table-empty-row">
                  <td colSpan="3" className="new-request-table-empty-cell">
                    There is no data to display
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="new-request-pagination-container">
          <span className="new-request-pagination-count">10</span>
          <button className="new-request-pagination-next-button">
            <FaChevronRight className="new-request-pagination-icon" />
          </button>
        </div>
      </div>

      {/* Provider Modal */}
      {isModalOpen && selectedProvider && (
        <div className="provider-modal-overlay">
          <div className="provider-modal">
            <div className="provider-modal-header">
              <h2>Review Provider Details</h2>
              <button
                className="provider-modal-close"
                onClick={() => setIsModalOpen(false)}
              >
                &times;
              </button>
            </div>

            <div className="provider-modal-content">
              <div className="provider-request-section">
                <h3>Provider Request</h3>
                <p>{selectedProvider.provider}</p>
                {selectedProvider.doctor && <p>{selectedProvider.doctor}</p>}
              </div>

              <div className="provider-location-section">
                <h3>For Records:</h3>
                <p>{selectedProvider.provider}</p>
                <p>{selectedProvider.address}</p>
                <p>Phone: {selectedProvider.phone}</p>
                {selectedProvider.fax && <p>Fax: {selectedProvider.fax}</p>}
              </div>

              <div className="provider-update-info">
                <p>
                  If you believe the above information is incorrect, please{" "}
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      // Handle update information click
                      alert(
                        "Update information feature would be implemented here"
                      );
                    }}
                  >
                    click here to update
                  </a>
                  . Our team will send your request to the updated location
                  instead.
                </p>
              </div>

              {selectedProvider.publicNotes && (
                <div className="provider-notes-section">
                  <p>
                    Public Notes:{" "}
                    {selectedProvider.publicNotes.replace(
                      "Medchart platform",
                      "Nobel Flow platform"
                    )}
                  </p>
                </div>
              )}

              <div className="provider-checkbox-section">
                <label className="provider-checkbox-label">
                  <input
                    type="checkbox"
                    className="provider-checkbox"
                    checked={hasAgreed}
                    onChange={(e) => setHasAgreed(e.target.checked)}
                  />
                  I've read the above and would like to proceed with the request
                </label>
              </div>

              <div className="provider-modal-footer">
                <button
                  className="provider-modal-proceed"
                  onClick={() => {
                    if (hasAgreed) {
                      setIsModalOpen(false);
                      setShowDateRangeScreen(true);
                    } else {
                      alert(
                        "Please confirm that you have read and agree to proceed"
                      );
                    }
                  }}
                  disabled={!hasAgreed}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
